import script from "./ClientesContratos.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientesContratos.vue?vue&type=script&lang=ts&setup=true"

import "./ClientesContratos.vue?vue&type=style&index=0&id=30921e55&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30921e55"]])

export default __exports__